import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import { Brand } from './Brand';

export const SiteHeader = ({ path }: { path: string }) => {
  const onGuides = path === '/conseils' || path.startsWith('/conseils/');
  const onTools = path === '/outils' || path.startsWith('/outils/');

  return (
    <header className="as-header">
      <a href="/" aria-label="Auto Sens, accueil">
        <Brand />
      </a>
      <nav className="as-nav" aria-label="Navigation principale">
        <a href="/a-propos/" aria-current={path === '/a-propos' ? 'page' : undefined}>À propos</a>
        <a href="/outils/" aria-current={onTools ? 'page' : undefined}>Outils</a>
        <a href="/conseils/" aria-current={onGuides ? 'page' : undefined}>Conseils</a>
      </nav>
      <a className="as-header-cta" href="/#contact">
        Décrire mon besoin
        <ArrowDownRight size={17} aria-hidden="true" />
      </a>
    </header>
  );
};

export const SiteFooter = () => (
  <footer className="as-footer">
    <div className="as-footer-intro" data-motion="split">
      <a href="/" aria-label="Auto Sens, accueil"><Brand compact reverse /></a>
      <p>
        Conseiller automobile indépendant pour particuliers. Des choix fondés sur l’usage,
        le coût global et des sources vérifiables — sans rémunération d’une marque, d’un vendeur,
        d’une plateforme ou d’un financement.
      </p>
    </div>

    <nav className="as-footer-links" aria-label="Navigation de pied de page" data-motion="stagger-links">
      <div>
        <strong>Choisir une voiture</strong>
        <a href="/conseils/quelle-citadine-15000-euros/">Citadine à 15 000 €</a>
        <a href="/conseils/quel-suv-30000-euros/">SUV à 30 000 €</a>
        <a href="/conseils/verifier-voiture-occasion/">Vérifier une occasion</a>
      </div>
      <div>
        <strong>Comprendre</strong>
        <a href="/conseils/essence-diesel-hybride-electrique/">Hybride, diesel ou essence</a>
        <a href="/conseils/achat-credit-loa-lld/">Achat, crédit, LOA ou LLD</a>
        <a href="/conseils/">Tous les conseils</a>
      </div>
      <div>
        <strong>Auto Sens</strong>
        <a href="/a-propos/">Enzo Chevallier</a>
        <a href="/outils/">Outils gratuits</a>
        <a href="/#methode">La méthode</a>
        <a href="/#dossier">Le dossier remis</a>
        <a href="/#contact">Décrire votre besoin <ArrowUpRight size={13} aria-hidden="true" /></a>
      </div>
    </nav>

    <div className="as-footer-base">
      <span>© 2026 Auto Sens</span>
      <span>Conseil automobile indépendant · Angers et à distance</span>
      <a href="/confidentialite/">Confidentialité</a>
      <a href="#top">Retour en haut ↑</a>
    </div>
  </footer>
);
